import {
  GET_PRODUCT_UNIT_BY_PRODUCT_ID_REQUEST,
  GET_PRODUCT_UNIT_BY_PRODUCT_ID_RESPONSE,
  GET_PRODUCT_UNIT_TYPE_REQUEST,
  GET_PRODUCT_UNIT_TYPE_RESPONSE,
  ADD_PRODUCT_UNIT_REQUEST,
  ADD_PRODUCT_UNIT_RESPONSE,
  UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
  UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
  DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
  DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
  UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_REQUEST,
  UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_RESPONSE,
} from "./actionTypes";

export const getProductUnitByProductIdRequest = (productId) => {
  return {
    type: GET_PRODUCT_UNIT_BY_PRODUCT_ID_REQUEST,
    payload: { productId },
  };
};

export const getProductUnitByProductIdResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_UNIT_BY_PRODUCT_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const addProductUnitRequest = (data) => {
  return {
    type: ADD_PRODUCT_UNIT_REQUEST,
    payload: { data },
  };
};

export const addProductUnitResponse = (apiResponse) => {
  return {
    type: ADD_PRODUCT_UNIT_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductUnitByProductUnitIdRequest = (
  productUnitId,
  data
) => {
  return {
    type: UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
    payload: { productUnitId, data },
  };
};

export const updateProductUnitByProductUnitIdResponse = (apiResponse) => {
  return {
    type: UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateProductUnitStatusByProductUnitIdRequest = (
  productUnitId,
  status
) => {
  return {
    type: UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_REQUEST,
    payload: { productUnitId, status },
  };
};

export const updateProductUnitStatusByProductUnitIdResponse = (apiResponse) => {
  return {
    type: UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteProductUnitByProductUnitIdRequest = (productUnitId) => {
  return {
    type: DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
    payload: { productUnitId },
  };
};

export const deleteProductUnitByProductUnitIdResponse = (apiResponse) => {
  return {
    type: DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const getProductUnitTypeRequest = () => {
  return {
    type: GET_PRODUCT_UNIT_TYPE_REQUEST,
  };
};

export const getProductUnitTypeResponse = (apiResponse) => {
  return {
    type: GET_PRODUCT_UNIT_TYPE_RESPONSE,
    payload: { apiResponse },
  };
};
